import CakeIcon from '@mui/icons-material/Cake';
import WorkIcon from '@mui/icons-material/Work';
import { Avatar } from '@mui/material';
import type { CelebrationInformation } from 'src/models/celebrations';
import CelebrationWheel from 'src/content/dashboards/Cards/components/CelebrationWheel';

export { CakeIcon, WorkIcon, Avatar ,CelebrationWheel};
export type { CelebrationInformation };

export const getCelebrationEvents = (celebration: CelebrationInformation) => {
  const events = [];

  if (celebration.birthday) {
    events.push({
      label: 'Birthday',
      date: celebration.dob,
      icon: CakeIcon,
      color: "#FF7043",
    });
  }

  if (celebration.milestone) {
    events.push({
      label: 'Work Anniversary',
      date: celebration.joinedDate,
      icon: WorkIcon,
      color: "#3F51B5",
    });
  }

  return events;
};

export const getDaysUntil = (date: Date | string) => {
  const today = new Date();
  const event = new Date(date);

  // Create the event date for the current year
  const eventThisYear = new Date(today.getFullYear(), event.getMonth(), event.getDate());

  // Difference in milliseconds
  const diffTime = eventThisYear.getTime() - today.setHours(0, 0, 0, 0);

  // Difference in days
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const getNumberSuffix = (n: number): string => {
  const j = n % 10,
    k = n % 100;
  if (j === 1 && k !== 11) return 'st';
  if (j === 2 && k !== 12) return 'nd';
  if (j === 3 && k !== 13) return 'rd';
  return 'th';
};

